import { render, staticRenderFns } from "./ProductMetaPrice.vue?vue&type=template&id=01436649&scoped=true&"
import script from "./ProductMetaPrice.vue?vue&type=script&lang=js&"
export * from "./ProductMetaPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01436649",
  null
  
)

export default component.exports